import React, { useRef, memo } from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'framer-motion';
import { HeartIcon, GlobeIcon } from 'lucide-react';
export function WhyReadSection() {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-80px'
  });
  return <section ref={ref} className="w-full bg-[#0a0a0a] py-24 px-6" data-id="element-328">
      <div className="max-w-5xl mx-auto" data-id="element-329">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        duration: 0.7
      }} className="text-center mb-16" data-id="element-330">
          <p className="text-[#CF9B2E] uppercase tracking-[0.3em] text-sm font-bold mb-4 font-['Lato']" data-id="element-331">
            Un libro para todos
          </p>
          <h2 className="text-4xl md:text-5xl font-bold text-[#F5F0E8] mb-6" data-id="element-332">
            ¿Por qué leer esta historia?
          </h2>
          <div className="gold-divider" data-id="element-333" />
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-334">
          {/* Lado A — Para Venezolanos */}
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} animate={isInView ? {
          opacity: 1,
          x: 0
        } : {}} transition={{
          duration: 0.7,
          delay: 0.15
        }} className="bg-[#111111] border border-[#C0392B]/20 p-10 rounded-sm relative overflow-hidden" data-id="element-335">
            <div className="absolute top-0 left-0 w-1 h-full bg-gradient-to-b from-[#C0392B] to-[#CF9B2E]" data-id="element-336" />
            <div className="flex items-center gap-3 mb-6" data-id="element-337">
              <div className="w-12 h-12 rounded-full bg-[#C0392B]/15 flex items-center justify-center" data-id="element-338">
                <HeartIcon className="w-6 h-6 text-[#C0392B]" data-id="element-339" />
              </div>
              <div data-id="element-340">
                <p className="text-[#CF9B2E] uppercase tracking-[0.2em] text-xs font-bold font-['Lato']" data-id="element-341">
                  Para venezolanos
                </p>
                <p className="text-[#F5F0E8] font-bold text-lg" data-id="element-342">
                  Tu historia, tu memoria
                </p>
              </div>
            </div>
            <p className="text-[#E8D5B0] text-lg leading-relaxed" style={{
            fontFamily: 'Playfair Display, serif',
            fontStyle: 'italic'
          }} data-id="element-343">
              Recupera la memoria, entiende la traición y visualiza la justicia
              que todos esperamos para 2026.
            </p>
          </motion.div>

          {/* Lado B — Para el Mundo */}
          <motion.div initial={{
          opacity: 0,
          x: 30
        }} animate={isInView ? {
          opacity: 1,
          x: 0
        } : {}} transition={{
          duration: 0.7,
          delay: 0.3
        }} className="bg-[#111111] border border-[#1A5276]/20 p-10 rounded-sm relative overflow-hidden" data-id="element-344">
            <div className="absolute top-0 left-0 w-1 h-full bg-gradient-to-b from-[#1A5276] to-[#CF9B2E]" data-id="element-345" />
            <div className="flex items-center gap-3 mb-6" data-id="element-346">
              <div className="w-12 h-12 rounded-full bg-[#1A5276]/15 flex items-center justify-center" data-id="element-347">
                <GlobeIcon className="w-6 h-6 text-[#4A90C4]" data-id="element-348" />
              </div>
              <div data-id="element-349">
                <p className="text-[#CF9B2E] uppercase tracking-[0.2em] text-xs font-bold font-['Lato']" data-id="element-350">
                  Para el mundo
                </p>
                <p className="text-[#F5F0E8] font-bold text-lg" data-id="element-351">
                  Una lección que no se repite
                </p>
              </div>
            </div>
            <p className="text-[#E8D5B0] text-lg leading-relaxed" style={{
            fontFamily: 'Playfair Display, serif',
            fontStyle: 'italic'
          }} data-id="element-352">
              Descubre las tácticas geopolíticas, las redes de poder
              internacionales y la lección histórica que nadie debería ignorar.
            </p>
          </motion.div>
        </div>
      </div>
    </section>;
}